import { useFragment } from "react-relay";
import graphql from "babel-plugin-relay/macro";

import { InspectionFieldMap$key } from "./__generated__/InspectionFieldMap.graphql";
import { openNavigation } from "../../../utils";
import { Portal } from "../../../components/Map/MapPortal";
import Button from "../../../components/Buttons/Button";
import FieldMapContainer from "../../../components/FieldMap";

export function InspectionFieldMap(props: {
  inspectionfield: InspectionFieldMap$key;
}) {
  const data = useFragment(
    graphql`
      fragment InspectionFieldMap on InspectionfieldNode {
        field {
          ...FieldMap
          geometry
        }
      }
    `,
    props.inspectionfield
  );
  if (!data.field) {
    return null;
  }
  const handleClickNavigate = () => {
    openNavigation(data?.field?.geometry);
  };
  return (
    <div style={{ height: 225 }}>
      <FieldMapContainer field={data.field}>
        <Portal>
          <div
            style={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <Button
              icon="arrow-right"
              label="Route plannen"
              size="medium"
              color="dark"
              onClick={handleClickNavigate}
            />
          </div>
        </Portal>
      </FieldMapContainer>
    </div>
  );
}
